import React from "react";
import { Beer } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

export default function Dagda() {
  return (
    <SacredChatPage
      persona="dagda"
      personaLabel="Le Dagda"
      IconComponent={Beer}
      accent="#c48a3f"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #2a1a0c 0%, #150c05 55%, #080400 100%)",
        fg: "#f5e4c2",
        msgBg: "linear-gradient(180deg, rgba(32,20,10,0.92), rgba(14,8,3,0.95))",
        msgFg: "#d7bd92",
      }}
      title={{
        fr: <><span className="italic" style={{ color: "#c48a3f" }}>Le Dagda</span>, Père bon des Tuatha Dé Danann.</>,
        en: <><span className="italic" style={{ color: "#c48a3f" }}>The Dagda</span>, Good Father of the Tuatha Dé Danann.</>,
      }}
      subtitle={{
        fr: "Le « bon dieu » celtique, roi d'Ériu, maître du chaudron d'abondance (Undry), de la harpe à trois airs (Uaithne — sommeil, rire, chagrin), de la massue de vie-et-mort et de la lance invincible. Figure paternelle, nourricière, rieuse. Pendant masculin de Gaïa dans la cité celtique.",
        en: "The Celtic 'good god', king of Ériu, master of the cauldron of plenty (Undry), the three-strain harp (Uaithne — sleep, laughter, sorrow), the club of life-and-death and the invincible spear. A paternal, nourishing, laughing figure. Masculine counterpart of Gaia in the Celtic city.",
      }}
      greeting={{
        fr: "« Approche, mon petit. Mon chaudron a toujours de la place. Que veux-tu apprendre ? »",
        en: "\"Come closer, my little one. My cauldron always has room. What do you want to learn?\"",
      }}
      suggestions={{
        fr: [
          "Raconte-moi le Cath Maige Tuired.",
          "Explique les 4 trésors des Tuatha Dé Danann.",
          "Qu'est-ce que les 3 airs de la harpe Uaithne ?",
          "Qu'est-ce qu'un père peut transmettre sans imposer ?",
        ],
        en: [
          "Tell me about the Cath Maige Tuired.",
          "Explain the 4 treasures of the Tuatha Dé Danann.",
          "What are the 3 strains of the Uaithne harp?",
          "What can a father pass on without imposing?",
        ],
      }}
      playlist={PLAYLISTS.dagda}
    />
  );
}
